import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  theory: theory,
  descriptionHtml:
    "Although human voice (dialogue, commentary, etc.) is a valid content that is typically included in the listening tests like presented previously, a dedicated set of methods has been defined over the years for speech quality assessment in real-time communication systems . In this section, we provide an example of a custom test methodology used to evaluate noise and echo reduction.</br></br>In this example, the testing method is an adapted version of the third-party listening test for the double-talk scenario as described in [2]. One of its uses is quick engineering evaluation, which is an unavoidable part of the iterative development of various audio processing components implementing noise reduction, echo suppression, echo cancellation, etc. The test allows for evaluation of transmission quality during periods of double talk, which has a large impact on the naturalness of the conversation. As show in the illustration below, the test setup includes three participants connected to the same online conference. Two speakers (Person 1 and Person 2) are simultaneously reading prepared sentences. The third-party listener is positioned in the center of the communication and does not participate in the conversation - their role is to judge the selected transmission quality aspects. In this example, the participants joined the conference through a desktop test application. Two different PC models and their built-in microphone and speaker systems were used.</br></br><b>Before running the test, use headphones to listen to the provided speech samples of both participants so that you can identify each speaker by their voice.</b>",
  layout: {
    type: "table",
    options: {
      cols: 5,
      rows: 2,
      rowsSize: [1, 5],
      colsSize: [1, 3, 3, 3, 1],
      colSpan: {
        "1:1": 3,
      },
      components: [
        [
          [],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    theme: "default",
                    text: "Person 1",
                    icon: "cis-volume-high",
                    shape: "round",
                    size: "standard",
                    loop: true,
                    url: `${config.ASSETS_URL}/02/26/principle/person1.mp3`,
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
          [],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    theme: "default",
                    text: "Person 2",
                    icon: "cis-volume-high",
                    shape: "round",
                    size: "standard",
                    loop: true,
                    url: `${config.ASSETS_URL}/02/26/principle/person2.mp3`,
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
        ],
        [
          [],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/26/principle/slide3-figure1.svg`,
                  },
                },
              },
            },
          ],
          [],
          [],
        ],
      ],
    },
    styles: {
      width: "80%",
    },
  },
};

export default principle;
